// 新建任务页面
import React from "react";
// import moment from 'moment';
import { Steps } from "antd";
// 引入组件
import TaskBuildStep1 from "./taskBuildStep1";
import TaskBuildStep2 from "./taskBuildStep2";
import TaskBuildStep3 from "./taskBuildStep3";
// 引入样式
import "./index.styl";

const { Step } = Steps;

class TaskBuildStep extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    console.log(this.props);
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.taskName = window.LayoutTab.tabParam.taskName;
      this.taskId = window.LayoutTab.tabParam.taskId;
      this.createAccount = window.LayoutTab.tabParam.createAccount;
    }
    this.state = {
      taskName: this.taskName,
      taskId: this.taskId,
      createAccount: this.createAccount,
      stepKey: 1,
      refresh: 0,
      fileName: "",
    };
  }

  changeStep = (key, isNew) => {
    let refresh = this.state.refresh;
    if (isNew) {
      refresh++;
    }
    this.setState({
      stepKey: key,
      refresh: refresh,
    });
  };

  // 设置导入文件名
  setFileName = (file) => {
    this.setState({
      fileName: file,
    });
  };

  render() {
    const content = (
      <div className="page-task">
        <div className="step-content step-item" style={{ padding: "24px 90px" }}>
          <Steps current={this.state.stepKey - 1}>
            <Step key={1} title="上传"></Step>
            <Step key={2} title="校验"></Step>
            <Step key={3} title="批量修改"></Step>
          </Steps>
        </div>
        <div className="step-content">
          <div style={{ display: this.state.stepKey === 1 ? "block" : "none" }}>
            <TaskBuildStep1
              setFileName={this.setFileName}
              taskName={this.state.taskName}
              taskId={this.state.taskId}
              changeStep={this.changeStep}
            />
          </div>
          <div style={{ display: this.state.stepKey === 2 ? "block" : "none" }}>
            <TaskBuildStep2
              fileName={this.state.fileName}
              setFileName={this.setFileName}
              createAccount={this.state.createAccount}
              refresh={this.state.refresh}
              taskName={this.state.taskName}
              taskId={this.state.taskId}
              changeStep={this.changeStep}
            />
          </div>
          <div style={{ display: this.state.stepKey === 3 ? "block" : "none" }}>
            <TaskBuildStep3 addTab={this.props.onAdd} changeStep={this.changeStep} />
          </div>
        </div>
      </div>
    );
    return content;
  }
}

export default TaskBuildStep;



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/taskBuildStep.js